import { InputBase as MuiInputBase, InputBaseProps as MuiInputBaseProps } from '@mui/material';
import { forwardRef } from 'react';

type Props = Pick<
  MuiInputBaseProps,
  | 'value'
  | 'onChange'
  | 'onBlur'
  | 'onFocus'
  | 'onKeyDown'
  | 'onKeyUp'
  | 'onPaste'
  | 'placeholder'
  | 'disabled'
  | 'error'
  | 'autoFocus'
  | 'autoComplete'
  | 'fullWidth'
  | 'multiline'
  | 'type'
  | 'name'
  | 'id'
  | 'className'
  | 'sx'
> & {
  testId?: string;
  ariaLabel?: string;
  ariaDescribedBy?: string;
};

const BaseInput = forwardRef<HTMLInputElement, Props>(
  (
    {
      value,
      onChange,
      onBlur,
      onFocus,
      onKeyDown,
      onKeyUp,
      onPaste,
      placeholder,
      disabled,
      error,
      autoFocus,
      autoComplete,
      fullWidth = true,
      multiline,
      type,
      name,
      id,
      className,
      sx,
      testId,
      ariaLabel,
      ariaDescribedBy,
    },
    ref,
  ) => (
    <MuiInputBase
      inputRef={ref}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      onPaste={onPaste}
      placeholder={placeholder}
      disabled={disabled}
      error={error}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      fullWidth={fullWidth}
      multiline={multiline}
      type={type}
      name={name}
      id={id}
      className={className}
      sx={sx}
      inputProps={{
        'test-id': testId,
        'aria-label': ariaLabel,
        'aria-describedby': ariaDescribedBy,
      }}
    />
  ),
);

BaseInput.displayName = 'BaseInput';
export type { Props as BaseInputProps };
export default BaseInput;
